import styled from "styled-components";

export const LandingTopbarContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 105;
  width: 100%;
  margin-bottom: 30px;

  &,
  .icon-plus-text,
  .star-icon {
    color: ${({ theme }) => theme.colors?.headerTextColor} !important;
  }

  .icon-plus-text {
    display: flex;
    text-decoration: none;

    p {
      font-size: 16px;
      margin: 0 0 8px;
    }

    transition: 0.4s transform;

    &:hover {
      transform: translateX(-5px);
    }
  }

  .star-icon {
    font-size: 26px;
  }
`;

export const Centralizer = styled.div`
  display: flex;
  justify-content: space-between;

  width: 100%;
  max-width: 1600px;
  margin: -32px 0px;
  padding: 32px 0;

  .anticon svg {
    color: rgb(255, 168, 0);
  }

  button {
    display: flex;
    border: none;
    background: none;
    cursor: pointer;

    svg {
      margin-right: 0.5rem;
      color: ${({ theme }) => theme.colors?.headerTextColor};
    }

    p {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors?.headerTextColor} !important;
      margin: 0;
    }
  }

  @media screen and (max-width: 575px) {
    padding: 2rem 5px;
  }
`;
